
import React from "react";
import { Button } from "@/components/ui/button";
import { Mic, MicOff } from "lucide-react";

interface VoiceControlsProps {
  isRecording: boolean;
  isLoading: boolean;
  isSpeaking: boolean;
  isProcessingAudio: boolean;
  hasVoiceInput: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
}

export const VoiceControls: React.FC<VoiceControlsProps> = ({
  isRecording,
  isLoading,
  isSpeaking,
  isProcessingAudio,
  hasVoiceInput,
  onStartRecording,
  onStopRecording
}) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={isRecording ? onStopRecording : onStartRecording}
        disabled={isLoading || isSpeaking || isProcessingAudio}
        className={`px-2.5 ${isRecording ? 'text-red-500 hover:text-red-700 bg-red-50' : 'text-blue-600 hover:text-blue-800'}`}
      >
        {isRecording ? (
          <>
            <MicOff className="h-4 w-4 mr-1" />
            <span>Arrêter</span>
          </>
        ) : (
          <>
            <Mic className="h-4 w-4 mr-1" />
            <span>Parler</span>
          </>
        )}
      </Button>
      
      {hasVoiceInput && !isRecording && !isProcessingAudio && (
        <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full">
          🎤 Message vocal prêt
        </span>
      )}
      
      {isRecording && (
        <span className="text-xs text-orange-600 bg-orange-50 px-2 py-1 rounded-full animate-pulse">
          🔴 Cliquez Envoyer pour traiter automatiquement
        </span>
      )}
      
      {isProcessingAudio && (
        <span className="text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded-full animate-pulse">
          ⚡ Traitement audio...
        </span>
      )}
    </div>
  );
};
